import styles from '@/components/Layout/components/MainContent/MainContent.module.css';

interface MainContentProps {
    children: React.ReactNode;
}

const MainContent = ({ children }: MainContentProps) => {
    return <main className={styles.main}>{children}</main>;
};

export default MainContent;
